import React from 'react';
import PropTypes from 'prop-types';

import i18n from '../../../../../shared/locales/no.json';

import AmbassadorForm from './AmbassadorForm';

export default class AmbassadorAdder extends React.Component {
    static propTypes = {
        onSave: PropTypes.func.isRequired,
    };

    state = {
        showForm: false,
    };

    handleFormCompletion = () => {
        this._hideForm();
    };

    _showForm = () => {
        this.setState({ showForm: true });
    };

    _hideForm = () => {
        this.setState({ showForm: false });
    };

    renderFormToggle() {
        if (this.state.showForm) {
            return (
                <AmbassadorForm
                    onCancel={this._hideForm}
                    onCompletion={this.handleFormCompletion}
                    onSave={this.props.onSave}
                />
            );
        } else {
            return (
                <React.Fragment>
                    <p>{i18n.ambassadors.intro}</p>
                    <p>{i18n.ambassadors.protip}</p>
                    <button
                        className="button button--small u-mt8"
                        onClick={this._showForm}
                        type="button"
                    >
                        {i18n.ambassadors.add_ambassador}
                    </button>
                </React.Fragment>
            );
        }
    }

    render() {
        return <div className="panel">{this.renderFormToggle()}</div>;
    }
}
